import axios from 'axios'

const provisional_brokerage_company_form = {
  namespaced: true,
  state() {
    return {
      data: {
        email: null,
        management_company_code: null,
      },
      errors: {},
    }
  },

  getters: {
    parameters(state) {
      return Object.assign({}, state.data);
    },
  },

  mutations: {
    setErrors(state, errors) {
      state.errors = {...errors}
    },
    resetData(state) {
      state.data.email = null;
      state.data.management_company_code = null;
    },
    setManagementCompanyCode(state, data) {
      state.data.management_company_code = data;
    },
    clearError(state) {
      state.errors = {}
    },
    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
  },

  actions: {
    send({getters, commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/sanctum/csrf-cookie').then(() => {
          axios.post('/api/brokerage_companies/provisional', getters.parameters).then(() => {
            commit('setFlashMessage', {value: '送信しました'}, {root: true});
            commit('resetData')
            commit('clearError')
            resolve(true)
          }).catch((error) => {
            let handled = false;
            if (error.response.status === 422) {
              commit('setErrors', error.response.data.errors);
              handled = true;
            }
            reject({handled});
          });
        }).catch(() => reject());
      });
    }
  }
}

export default provisional_brokerage_company_form;
